import { useEffect, useState } from 'react';

import { whenAirgapReady } from '@/layouts/ConsentSync';

/** The loaded Airgap API, or null until airgap.js finishes loading (or when it never does). */
export const useAirgap = () => {
  const [airgap, setAirgap] = useState<Awaited<ReturnType<typeof whenAirgapReady>>>(null);

  useEffect(() => {
    let mounted = true;
    whenAirgapReady().then((api) => {
      if (mounted) setAirgap(api);
    });

    return () => {
      mounted = false;
    };
  }, []);

  return airgap;
};
